import React from "react";
import { UserSideBar } from "./UserSideBar";
import { ArtistSidebar } from "./ArtistSideBar";
import { AdminSidebar } from "./AdminSideBar";

export const Sidebar = () => {

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const role = authUser?.user?.user_type;

  return (
    <>
      {role == 1 && <UserSideBar />}
      {role == 2 && <ArtistSidebar />}
      {role == 3 && <AdminSidebar />}
    </>
  );
};
